var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 53.5,
    height: 53.5,
    rx: 11.75,
    fill: "white",
    fillOpacity: 0.1,
    stroke: "#F8BC32",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7286 34.8987L38.5088 28.9186C38.4344 28.5764 38.4195 28.1896 37.8542 27.8326L36.6195 13.4029C36.6046 13.2243 36.679 13.2243 36.5005 13.2392C26.6823 14.102 22.517 12.0789 20.5683 11.0376C20.3303 10.9186 20.0476 11.0971 20.0625 11.3648C20.1071 12.0045 20.5236 12.9566 22.7402 13.626C26.5484 14.8012 32.9451 14.221 35.8013 13.983C35.965 13.9682 35.8906 13.9682 35.9055 14.1467L37.1848 27.4607L36.0989 26.8359L34.5369 15.8574C34.522 15.5301 34.1947 15.307 33.8823 15.3963C26.1022 17.8805 20.5683 18.6987 19.0063 18.0442C18.6344 17.8954 18.3964 18.1186 18.5005 18.5351C18.6195 19.026 19.1699 19.7252 21.1782 19.6062C23.6625 19.4425 32.5881 16.631 33.7187 16.2739C33.8228 16.2442 33.9121 16.3632 33.9121 16.4673L35.4592 26.4938L30.0741 23.712C29.6278 23.4739 29.0922 23.4144 28.6013 23.5483L20.9848 25.5715C20.5385 25.6905 20.1517 25.9434 19.884 26.3153L15.4212 32.1764C14.722 33.0839 14.9154 34.3929 15.8377 35.0772L25.7749 42.3367C26.1319 42.5896 26.5484 42.7235 26.9798 42.7384L33.2873 42.7533C33.8972 42.7533 34.4774 42.4855 34.8641 42.0095L39.3121 36.6392C39.6989 36.1483 39.8625 35.5086 39.7286 34.8987Z",
    fill: "#F8BC32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2789 27.7133C27.7831 27.6241 25.9087 30.0489 25.9087 32.9348C25.9087 35.8208 28.036 37.7695 30.8922 37.7695C33.7484 37.7695 36.1136 36.6241 36.2475 33.1133C36.3517 30.2274 35.117 27.8026 31.2789 27.7133ZM32.3798 34.7348C31.4575 34.7348 30.7285 33.991 30.7285 33.0836C30.7285 32.1613 31.4723 31.4323 32.3798 31.4323C33.3021 31.4323 34.031 32.1761 34.031 33.0836C34.0459 33.991 33.3021 34.7348 32.3798 34.7348Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.acec6c873bd79aa0ccde8a59ef892fd0.svg";
export { ForwardRef as ReactComponent };